import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { lastValueFrom } from 'rxjs';
import { MenuEntity, MenuItemEntity, MenuRestControllerService,} from 'src/app/swagger';

@Component({
  selector: 'app-menu-selection',
  templateUrl: './menu-selection.component.html',
  styleUrls: ['./menu-selection.component.scss'],
  standalone: false,
})
export class MenuSelectionComponent implements OnInit {
  public static readonly id = 'menu-selection-modal';

  public menus: MenuEntity[];

  @Input()
  restaurantId: string | null = null;

  @Input()
  restaurantBranchId: string | null = null;

  constructor(
    private modalController: ModalController,
    private menuService: MenuRestControllerService
  ) {}

  public ngOnInit() {
    this.init();
  }

  public onCloseClick() {
    this.modalController.dismiss(null, '', MenuSelectionComponent.id);
  }

  public onMenuClick(_: MouseEvent, menu: MenuItemEntity, index: number) {
    this.modalController.dismiss(
      { selectedMenu: menu },
      '',
      MenuSelectionComponent.id
    );
  }

  private init() {
    this.setMenus();
  }

  private async setMenus(): Promise<void> {
    this.menus = [];
    const resp = await lastValueFrom(
      this.menuService.getMenus(this.restaurantId, this.restaurantBranchId)
    );
    if (resp && resp?.items?.length > 0) {
      this.menus = resp?.items ?? [];
    }
  }
  
}
